import React from "react";

function ShippingBusIcon() {
  return (
    <svg
      width="31"
      height="26"
      viewBox="0 0 31 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.75 18.0833V0.75H0.75V18.0833H20.75ZM20.75 18.0833H30.0833V11.4167L26.0833 7.41667H20.75L20.75 18.0833ZM10.0833 21.4167C10.0833 23.2576 8.59095 24.75 6.75 24.75C4.90905 24.75 3.41667 23.2576 3.41667 21.4167C3.41667 19.5757 4.90905 18.0833 6.75 18.0833C8.59095 18.0833 10.0833 19.5757 10.0833 21.4167ZM27.4167 21.4167C27.4167 23.2576 25.9243 24.75 24.0833 24.75C22.2424 24.75 20.75 23.2576 20.75 21.4167C20.75 19.5757 22.2424 18.0833 24.0833 18.0833C25.9243 18.0833 27.4167 19.5757 27.4167 21.4167Z"
        stroke="#9810FB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ShippingBusIcon;
